import {Component, Input} from '@angular/core';

import {Word} from '../../models/word.model';
import {VoiceService} from '../../services/voice/voice.service';


@Component({
  selector: 'app-word-ex-play-btn',
  template: `
    <a class="sound-btn {{ on ? 'on' : '' }}"
       (click)="playSound($event)"></a>
  `,
  styleUrls: ['./word-ex-play-btn.component.scss'],
})
export class WordExPlayBtnComponent {
  @Input() word: Word;
  @Input() exNum: number; // 예문 번호

  constructor(
    private voice: VoiceService,
  ) { }

  public playSound(event: MouseEvent): void {
    event.stopPropagation();

    if (this.word) {
      if (this.on) {
        this.voice.Stop();
      }
      else {
        this.voice.PlaySound(this.word, this.exNum).subscribe();
      }
    }
    else {
      console.error('WordExPlayBtnComponent::playSound() invalid data', this);
    }
  }

  public get show(): boolean {
    return this.word && this.word.HaveExVoiceNth(this.exNum);
  }

  public get on(): boolean {
    return this.voice.on && this.voice.wordId === this.word.id && this.voice.noEx === this.exNum;
  }

}
